export enum RequestState {
  Waiting = 'waiting',
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
}
